import { render, staticRenderFns } from "./ActivityBox.vue?vue&type=template&id=e72cd042&scoped=true"
import script from "./ActivityBox.vue?vue&type=script&lang=js"
export * from "./ActivityBox.vue?vue&type=script&lang=js"
import style0 from "./ActivityBox.vue?vue&type=style&index=0&id=e72cd042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72cd042",
  null
  
)

export default component.exports